import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export const AuthAPI = {
    exchangeToken: async (code, codeVerifier, redirectUri) => {
        return axios.post(`${BASE_URL}/auth/callback`, {
            code,
            code_verifier: codeVerifier,
            redirect_uri: redirectUri
        });
    },

    getProfile: async (token) => {
        return axios.get(`${BASE_URL}/auth/profile`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
    }
}; 